export function getParsedJSONValues(stringifiedJSON: string, keys: string[]) {
  try {
    return (
      Object.entries(JSON.parse(stringifiedJSON))?.reduce(
        (acc, [key, value]) => {
          if (keys.indexOf(key) !== -1) {
            acc?.push(value)
          }
          return acc
        },
        [],
      ) ?? []
    )
  } catch {
    return Array.from(keys).fill(null)
  }
}
